import React from "react"
import { makeStyles } from "@material-ui/core"
import { ReactComponent as HMapLogo } from '../../../../components/1elements/Icons/svg/heatMap/hmapLogo.svg'

const HMapLeftPanelContent = ({ children, toggle }) => {
  const classes = useStyles({toggle})

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.left}>
          <HMapLogo />
        </div>
        <div className={classes.middle}>Heatmaps</div>
        <div className={classes.right}></div>
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default React.memo(HMapLeftPanelContent)

const useStyles = makeStyles((theme, props) => ({
  root: {
    width: '465px',
    height: '100%',
    display: (props) => (props.toggle ? 'block' : 'none'),
    flexDirection: 'column',
    borderRadius: '5px 0 0 5px',
    opacity: (props) => (props.toggle ? 1 : 0),
    transition: 'opacity .1s'
    // transitionDelay: '.1s'
  },
  header: {
    width: '100%',
    height: '50px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: '5px 0 0 0',
    backgroundColor: theme.palette.quaternary.accent
  },
  left: {
    width: '35%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  middle: {
    width: '30%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    ...theme.typography.h1,
    color: theme.palette.tertiary.main
  },
  right: {
    width: '35%'
  },
  content: {
    width: '100%',
    height: '90%',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0 0 0 5px',
    padding: '15px 0 0 0'
  }
}))
